import {
  LOAD_USER_PAYMENTS,
  LOAD_USER_PAYMENTS_FAIL,
  LOAD_USER_PAYMENTS_SUCCESS,
  LoadUserPaymentsSuccess, RESET_USER_PAYMENTS,
  UserPaymentsAction
} from "../actions";

export interface IUserPaymentsDataState {
  userPaymentsData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserPaymentsState {
  userPaymentsData: IUserPaymentsDataState;
}

export const initialState: IUserPaymentsState = {
  userPaymentsData: {
    userPaymentsData: null,
    loading: false,
    loaded: false
  }
};

export function reducer(state: IUserPaymentsState = initialState, action: UserPaymentsAction): IUserPaymentsState {
  let payload: any;

  switch (action.type) {
    case LOAD_USER_PAYMENTS:
      return {
        ...state,
        userPaymentsData: {
          ...state.userPaymentsData,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_PAYMENTS_SUCCESS:
      payload = (<LoadUserPaymentsSuccess>action).payload;

      return {
        ...state,
        userPaymentsData: {
          ...state.userPaymentsData,
          userPaymentsData: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_PAYMENTS_FAIL:
      return {
        ...state,
        userPaymentsData: {
          ...state.userPaymentsData,
          userPaymentsData: null,
          loading: false,
          loaded: true
        }
      };

    case RESET_USER_PAYMENTS:
      return {
        userPaymentsData: {
          userPaymentsData: null,
          loading: false,
          loaded: false
        },
      };
  }

  return state;
}
